import { Document_Type, Event_Type } from "../../../constant/constant";


export const emptyStates = {
    Others: {
        iconSrc: '/images/photo.png',
        title: "No media yet",
        description: "Your media library is empty. Start capturing and sharing memorable moments with your team!",
        action: "Upload Media"
    },
    Birthdays: {
        iconSrc: '/images/birthday-icon.png',
        title: "No birthday celebrations yet",
        description: "Share photos and videos from birthday celebrations to make team members feel special.",
        action: "Add Birthday Media"
    },
    Trainings: {
        iconSrc: '/images/work-anniversary-icon.png',
        title: "No training media yet",
        description: "Upload photos and videos from training sessions, workshops, and learning programs to build your training gallery.",
        action: "Add Training Media"
    },
    'Work Anniversary': {
        iconSrc: '/images/work-anniversary-icon.png',
        title: "No work anniversary posts",
        description: "Celebrate team milestones by uploading photos and videos from work anniversary celebrations.",
        action: "Add Anniversary Media"
    },
    Achievements: {
        iconSrc: '/images/achievement-icon.png',
        title: "No achievements shared",
        description: "Recognize outstanding work by sharing media from achievement celebrations and award ceremonies.",
        action: "Share Achievement"
    },
    Events: {
        iconSrc: '/images/event-icon.png',
        title: "No event media",
        description: "Capture the energy of team events, meetings, and gatherings to build lasting memories.",
        action: "Upload Event Media"
    }
};

type MediaHubTab = {
    label: keyof typeof Event_Type | string;
    path: string;
    documentType: Document_Type | null;
};

export const MediaHubTabs: MediaHubTab[] = [
    {label: Event_Type.BIRTHDAY, path: 'birthdays', documentType: Document_Type.BIRTHDAY_PHOTO},
    {label: Event_Type.CUSTOM_EVENT, path: 'events', documentType: Document_Type.EVENT_PHOTO},
    {label: Event_Type.TRAINING, path: 'trainings', documentType: Document_Type.TRAINING_PHOTO,},
    {label: 'Achievements', path: 'achievements', documentType: Document_Type.ACHIEVEMENT_PHOTO},
    {label: 'Others', path: 'others', documentType: Document_Type.MEMORIES},
];


export function mapPathWithCategories(pathSegments: string[]) {
    const match = MediaHubTabs.find(tab =>
        pathSegments.includes(tab.path)
    );

    return match?.label || "Others";
}


export const getDocumentKey = (
    tabName: string
): keyof typeof Document_Type | undefined => {

    const tab = MediaHubTabs.find(
        tab => tab.label === tabName
    );

    if (!tab) return undefined;
    return (Object.keys(Document_Type) as Array<keyof typeof Document_Type>)
        .find(
            key => Document_Type[key] === tab.documentType
        );
};
